let accordionExp;
let accordionArr = [];

document.querySelectorAll('.accordion').forEach(accordionSec => {
  accordionArr.push(accordionSec);
});

if(Boolean(accordionArr.length)) {
  accordionArr.forEach(accordionArrEl => {
    accordionArrEl.querySelector('.accordion__header').addEventListener('click', e => {
      if(e.target.closest('.accordion') == accordionArrEl) {
        accordionArrEl.classList.toggle('active');
        accordionExp = accordionArrEl.querySelector('.accordion__expander');

        switch(Boolean(accordionExp.style.height)) {
          case true:
            accordionExp.style.height = null;
            break;

          case false:
            accordionExp.style.height = `${accordionExp.scrollHeight}px`;
            break;
        }
      }
    });
  });
}